module.exports = __webpack_public_path__ + "static/media/tick_icon.01ab8276.svg";